export default function RestaurantWeeksSpringScreenshot(){
    return(
        <img src='screenshot-restaurant-week-spring.jpg' style={{maxWidth:'100%'}} />
    )
}